import { Box } from '@coolblue-development/freddy';
import {
  type InsuranceGroup,
  type InsuranceProvider,
  InsuranceSelector
} from '@coolblue-development/next-insurance/insurance-selector';

import { InsuranceSectionBox } from './InsuranceSectionBox';
import { InsuranceSectionTitle } from './InsuranceSectionTitle';
import { InsuranceSelectorConfiguredProvider } from './InsuranceSelectorConfiguredProvider';

type Props = {
  order: number;
  productId: number;
  productType?: string;
  insuranceGroups: InsuranceGroup[];
  provider: InsuranceProvider;
};

export function InsuranceSection({
  productId,
  productType = '',
  order,
  insuranceGroups,
  provider
}: Props) {
  return (
    <>
      <InsuranceSelectorConfiguredProvider
        productId={productId}
        insuranceGroups={insuranceGroups}
        provider={provider}
      >
        <InsuranceSectionBox>
          <InsuranceSectionTitle stepNumber={order} />

          <Box mt={400}>
            <InsuranceSelector productType={productType} />
          </Box>
        </InsuranceSectionBox>
      </InsuranceSelectorConfiguredProvider>
    </>
  );
}
